import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '@mui/material';
import styles from 'components/pages/common/EditField.module.scss';
export const MIN_EMAIL_LENGTH = 5;
const MAX_EMAIL_LENGTH = 100;
const emailPattern = `^(?=.{${MIN_EMAIL_LENGTH},${MAX_EMAIL_LENGTH}}$).+@.+\\..+$`;
export const emailRegex = new RegExp(emailPattern);
export function EmailField({ fieldName, value, onChange }) {
    return (_jsx(TextField, { type: 'email', inputProps: {
            minLength: MIN_EMAIL_LENGTH,
            maxLength: MAX_EMAIL_LENGTH,
            pattern: emailRegex
        }, InputLabelProps: {
            className: styles.inputLabel
        }, label: fieldName, onChange: onChange, value: value }));
}
